import React from 'react'

export default function InventoryReturns() {
  return (
    <div>ItemReturn</div>
  )
}
